export const BASE_URL = 'https://julapi.bazooka.se';

export const endpoints = {
  getHatches: `${BASE_URL}/api/hatches`,
  getHatch: (id) => `${BASE_URL}/api/hatches/${id}`,
};
